/*
__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\\\\\_____/\\\\\\\\\____        
 _\///////\\\/////__\///////\\\/////____/\\\\\\\\\\\\\__       
  _______\/\\\_____________\/\\\________/\\\/////////\\\_      
   _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_     
    _______\/\\\_____________\/\\\_______\/\\\\\\\\\\\\\\\_    
     _______\/\\\_____________\/\\\_______\/\\\/////////\\\_   
      _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_  
       _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_ 
        _______\///______________\///________\///________\///__
            
            COPYRIGHT TACTICAL TRANSPORTATION ADVISORS, INC. 
            ALL RIGHTS RESERVED.
*/

import { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import DashboardOld from "./DashboardOld/DashboardOld";
import DashboardOldHistorical from "./DashboardOldHistorical";
import DashboardTC2 from "./DashbordTC2/DashboardTC2";
import DashboardTC2Historical from "./DashbordTC2/DashboardTC2Historical";

const FEEDS = ["Employee Documents", "TC 2.0"];
const TABS = ["Active", "Historical"];

export default function Dashboard() {
  const [selectedFeed, setSelectedFeed] = useState("Employee Documents");
  const [selectedTab, setSelectedTab] = useState("Active");

  return (
    <div style={{ display: "flex", height: "100%", overflow: "hidden" }}>
      {/* Left sidebar — feed selector */}
      <div
        style={{
          width: 180,
          minWidth: 180,
          borderRight: "1px solid #dee2e6",
          padding: "16px 8px",
          display: "flex",
          flexDirection: "column",
          gap: 4,
          backgroundColor: "#f8f9fa",
        }}
      >
        <span style={{ fontSize: 11, fontWeight: 600, color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.05em", padding: "0 8px", marginBottom: 4 }}>Feed</span>
        <Nav variant="pills" className="flex-column">
          {FEEDS.map((feed) => (
            <Nav.Item key={feed}>
              <Nav.Link
                active={selectedFeed === feed}
                onClick={() => {
                  setSelectedFeed(feed);
                  setSelectedTab("Active");
                }}
                style={{ padding: "6px 12px", fontSize: 13, cursor: "pointer" }}
              >
                {feed}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>{" "}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ borderBottom: "1px solid #dee2e6", padding: "0 16px", backgroundColor: "#fff" }}>
          <Nav variant="tabs" style={{ border: "none" }}>
            {TABS.map((tab) => (
              <Nav.Item key={tab}>
                <Nav.Link active={selectedTab === tab} onClick={() => setSelectedTab(tab)} style={{ cursor: "pointer", fontSize: 14 }}>
                  {tab}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        <div style={{ flex: 1, overflow: "auto", padding: 16 }}>
          {selectedFeed === "Employee Documents" && selectedTab === "Active" && <DashboardOld />}
          {selectedFeed === "Employee Documents" && selectedTab === "Historical" && <DashboardOldHistorical />}
          {selectedFeed === "TC 2.0" && selectedTab === "Active" && <DashboardTC2 />}
          {selectedFeed === "TC 2.0" && selectedTab === "Historical" && <DashboardTC2Historical />}
        </div>
      </div>
    </div>
  );
}
